import { useContext } from 'react';
import { StoreContext } from '@roc/client-portal-shared/context';
import { InsuranceDetailsGridStore } from '../stores/insuranceDetailsGridStore';


export const useInsuranceDetailsGridStore = () =>
  useContext<{
    insuranceDetailsGridStore?: InsuranceDetailsGridStore;
  }>(StoreContext);
